// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__34ujG","notes":"Notes_notes__3kToI","note":"Notes_note__38K2s","markdown":"Notes_markdown__3AAL2"};